import { AsyncPipe, CommonModule } from "@angular/common";
import { Component, Input, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatPseudoCheckboxModule } from "@angular/material/core";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import { AppState } from "../../../app.state";
import { ConfirmDialogComponent } from "../../../confirm-dialog/confirm-dialog.component";
import { ICTema, IPermisos, IUsuario } from "../../../interfaces/catalogos.";
import { LoadingService } from "../../../loading/loading.service";
import { UsuariosService } from "../../../services/catalogos/usuarios/usuarios.service";
import { TemasService } from "../../../services/temas/temas.service";
import { showHideCatalogo } from "../../../states/admon-catalogos/actions";
import { selectCatalogoUsuuarioStatus } from "../../../states/admon-catalogos/selector";
import { selectUsuario } from "../../../states/usuario/selector";
import { emailPatternValidator, nombreUsuario } from "../../utils";
import { CAT_ACCIONES, CAT_PERMISOS, CAT_ROLES } from "./fixtures";

@Component({
  selector: "app-add-usuario",
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatListModule,
    MatPseudoCheckboxModule,
    MatSelectModule,
    MatChipsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
    MatCheckboxModule,
  ],
  templateUrl: "./add-usuario.component.html",
  styleUrl: "./add-usuario.component.css",
})
export class AddUsuarioComponent {
  @Input() usuarios: IUsuario[] = [];

  private store: Store<AppState> = inject(Store);
  admonCatUsuariosStatus$ = this.store.pipe(
    select(selectCatalogoUsuuarioStatus)
  );

  catRoles = CAT_ROLES;
  catAcciones = CAT_ACCIONES;
  catTemas: ICTema[] = [];

  favoriteSeason!: string;

  nuevo = false;
  descripcion = "";
  existe = false;
  nuevoRegistro!: FormGroup;
  permisosSeleccionados: IPermisos[] = [];

  public user$!: Observable<any>;

  constructor(
    private fb: FormBuilder,
    private usuariosService: UsuariosService,
    public dialog: MatDialog,
    public temasService: TemasService,
    public loadingService: LoadingService
  ) {}

  ngOnInit() {
    this.user$ = this.store.pipe(select(selectUsuario));

    this.initForm();
  }

  initForm() {
    this.temasService.cargarTemas().subscribe((temas) => {
      this.catTemas = temas;
    });
    this.nuevoRegistro = this.fb.group({
      nombre: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(75),
          nombreUsuario(),
        ],
      ],
      mail: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(150),
          emailPatternValidator(),
        ],
      ],

      rol: ["", [Validators.required]],
      formaEnvio: [false, [Validators.required]],
      tema: ["", [Validators.required]],
      accion: ["", [Validators.required]],
      notificacion: [false, [Validators.required]],
    });
    this.permisosSeleccionados = [];
  }

  hideNuevo() {
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "usuarios",
        mostrarEditar: false,
        mostrarNuevo: false,
        guardando: false,
      })
    );
    this.initForm();
  }
  nuevoTipo() {
    this.nuevo = !this.nuevo;
  }

  guardarRegistro() {
    this.loadingService.show();
    const temas = this.permisosSeleccionados.map((tema: any) => {
      return {
        tId: tema.temaId,
        tema: tema.descripcionTema,
        accion: tema.accionId,
        notificacion: tema.notificacion,
      };
    });
    const payload: IUsuario = {
      id: "",
      activo: true,
      formaEnvio: this.nuevoRegistro.value.formaEnvio,
      mail: this.nuevoRegistro.value.mail,
      mostrar: true,
      nombre: this.nuevoRegistro.value.nombre,
      rol: this.nuevoRegistro.value.rol,
      temas,
    };

    console.log("payload", payload);
    if (this.permisosSeleccionados.length <= 0) {
      this.showModal(
        "Datos incompletos",
        "Favor de capturar al menos un permiso."
      );
      return;
    }

    if (!this.validateFilds()) {
      this.usuariosService.guardarUsuario(payload).subscribe(
        (data) => {
          console.log("data", data);
          if (data.exito) {
            this.store.dispatch(
              showHideCatalogo({
                tipoCatalogo: "usuarios",
                mostrarEditar: false,
                mostrarNuevo: false,
                guardando: true,
              })
            );
            this.initForm();
            this.cargarUsuaarios();
            this.loadingService.hide();
          } else if (data.error) {
            this.loadingService.hide();
            this.showModal(data.message.title, data.message.message);
          }
        },
        (error) => {}
      );
    }
  }

  ocultarBotones(ocultar: boolean) {
    const rol = this.nuevoRegistro.get("rol");
    rol?.setValue(1);
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "usuarios",
        mostrarEditar: false,
        mostrarNuevo: true,
        guardando: false,
      })
    );
  }
  existeRegistro(event: Event, length: number): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length > length) {
      input.value = input.value.substring(0, length);
    }

    const nuevaDescripcion = input.value?.trim().toLowerCase() || "";
    const nombresEmpresasSet = new Set(
      this.usuarios.map((usuario: any) => usuario.nombre.toLowerCase())
    );
    this.existe = nombresEmpresasSet.has(nuevaDescripcion);
  }

  nuevoPermiso() {
    if (!this.nuevoRegistro.value.tema || !this.nuevoRegistro.value.accion) {
      this.showModal("Datos incompletos", "Favor de capturar tema y acción.");
      return;
    }

    const newPermiso: IPermisos = {
      temaId: this.nuevoRegistro.value.tema.id,
      accionId: this.nuevoRegistro.value.accion.accion,
      descripcionTema: this.nuevoRegistro.value.tema.descripcion,
      descChip: `${this.nuevoRegistro.value.tema.descripcion} - ${
        this.nuevoRegistro.value.accion.label
      } ${this.nuevoRegistro.value.notificacion ? " - Notifi..." : ""}`,
      notificacion: this.nuevoRegistro.value.notificacion,
    };
    this.permisosSeleccionados.push(newPermiso);

    this.catTemas = this.catTemas.filter(
      (cat) => cat.descripcion !== this.nuevoRegistro.value.tema.descripcion
    );
    this.clearCombos();
  }

  removePermiso(permiso: IPermisos) {
    this.permisosSeleccionados = this.permisosSeleccionados.filter(
      (select) => select.temaId !== permiso.temaId
    );

    const permisoToAdd = CAT_PERMISOS.find(
      (r) => r.descripcion === permiso.descripcionTema
    );
    if (permisoToAdd) {
      this.catTemas.push(permisoToAdd);
    }
    this.clearCombos();
  }

  clearCombos() {
    this.nuevoRegistro.patchValue({
      tema: "",
      accion: "",
      notificacion: false,
    });
  }

  showModal(title: string, message: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title,
        message,
        showButtons: {
          accept: true,
          cancel: false,
        },
        buttonsName: { cancel: "", accept: "Aceptar" },
        direction: "end",
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {
      this.loadingService.hide();
    });

    dialogRef.componentInstance.cancelAction.subscribe(() => {
      this.loadingService.hide();
    });
  }

  validateFilds() {
    if (
      this.nuevoRegistro.value.nombre &&
      this.nuevoRegistro.get("nombre")?.valid &&
      this.nuevoRegistro.get("mail")?.valid &&
      this.nuevoRegistro.value.mail &&
      this.nuevoRegistro.value.rol
    ) {
      return false;
    }
    return true;
  }

  cargarUsuaarios() {
    this.usuariosService.cargarUsuarios().subscribe(
      (response) => {
        console.log("cargarUsuaarios", response);

        this.usuarios = response;
        this.loadingService.hide();
      },
      (error) => {
        this.loadingService.hide();
      }
    );
  }
}
